import React from 'react';

const EmptyState = ({ 
  message = 'No items found',
  // "= undefined" makes the prop optional for TypeScript callers.
  action = undefined,
  actionText = undefined,
  onActionClick = undefined,
  className = '',
  ...props 
}) => {
  return (
    <div className={`text-center py-12 ${className}`} {...props}>
      <div className="text-gray-500">{message}</div>
      {action && actionText && onActionClick && (
        <button
          onClick={onActionClick}
          className="mt-2 text-naviter-blue hover:text-naviter-blue-light"
        >
          {actionText}
        </button>
      )}
      {action && !actionText && action}
    </div>
  );
};

export default EmptyState;
